import { css } from 'styled-components'
import { color } from '../atoms'

export const scrollbarCss = css`
	&::-webkit-scrollbar {
		width: 5px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}

	&::-webkit-scrollbar-thumb {
		background: ${color('gray-06')};
		border-radius: 10px;
	}
`
